// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.attachment-modal-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 56px;
  cursor: pointer;
}

.attachment-modal-item:hover {
  background-color: rgb(245, 245, 245);
}

.attachment-modal-item-icon {
  height: 100%;
  width: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.attachment-modal-item-icon * {
  width: 24px;
  height: 24px;
}

.attachment-modal-item-label {
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: rgb(71, 71, 71);
}

.attachment-modal {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
}

.attachment-modal-reply-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  width: 100%;
  background-color: rgb(245, 248, 250);
  border-bottom: 1px solid rgb(224, 224, 224);
  color: rgb(71, 71, 71);
  font-family: 'Roboto', sans-serif;
  font-size: 13px;
}

.attachment-modal-reply-indicator .material-icons {
  font-size: 18px;
  color: rgb(100, 100, 100);
  margin-left: 10px;
}

.attachment-modal-reply-text {
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/components/Page/Conversations/ChatView/Messages/AttachmentModal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,WAAW;EACX,oCAAoC;EACpC,2CAA2C;EAC3C,sBAAsB;EACtB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".attachment-modal-item {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  width: 100%;\n  height: 56px;\n  cursor: pointer;\n}\n\n.attachment-modal-item:hover {\n  background-color: rgb(245, 245, 245);\n}\n\n.attachment-modal-item-icon {\n  height: 100%;\n  width: 56px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.attachment-modal-item-icon * {\n  width: 24px;\n  height: 24px;\n}\n\n.attachment-modal-item-label {\n  font-family: 'Roboto', sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  color: rgb(71, 71, 71);\n}\n\n.attachment-modal {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  width: 100%;\n  height: 100%;\n}\n\n.attachment-modal-reply-indicator {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n  width: 100%;\n  background-color: rgb(245, 248, 250);\n  border-bottom: 1px solid rgb(224, 224, 224);\n  color: rgb(71, 71, 71);\n  font-family: 'Roboto', sans-serif;\n  font-size: 13px;\n}\n\n.attachment-modal-reply-indicator .material-icons {\n  font-size: 18px;\n  color: rgb(100, 100, 100);\n  margin-left: 10px;\n}\n\n.attachment-modal-reply-text {\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
